const React = require('react');

/* eslint-disable */
module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={'dB fillCT>path ' + (props.className || '')}
    >
      <path
        d="M27 0C12.0893 0 0 12.0893 0 27C0 41.9108 12.0893 54 27 54C41.9108 54 54 41.9108 54 27C54 12.0893 41.9108 0 27 0ZM24.1875 38.907L14.0625 29.088L18.2407 24.9075L24.1875 30.546L36.8842 17.532L41.0625 21.7103L24.1875 38.907Z"
      />
    </svg>
  );
};
